/**
 * 全局 store，不要有更多依赖
 */

import { makeAutoObservable, runInAction } from 'mobx';
import { HelperCore } from '@src/common/helper';
import Local from '@src/common/helper/local';
import EE from '@src/common/event';
import { message } from 'antd';
import { reportToNRobotWithBasicInfo } from '@src/common/request';
import Conf, { isDS } from '@/common/conf';
import { request } from '@/common';
import navbarStore from './navbar';
import { MIOP } from '@/common/robust-websocket';
import lifecycle from 'page-lifecycle/dist/lifecycle.mjs';
import { uuidv4 } from '@/common/dependencies';

// 用户设置
const ZM_USER_CONFIG = "ZM_USER_CONFIG";
// 用户完成次数
const ZM_USER_ACTION_COUNT = "ZM_USER_ACTION_COUNT";

export const INVITE_STATUS_WAIT = 0; // 未申请
export const INVITE_STATUS_WAITTING = 1; // 申请中
export const INVITE_STATUS_SUCCESS = 2; // 已通过
export const INVITE_STATUS_ACTIVE = 3; // 已激活
export const INVITE_STATUS_FAIL = 9; // 拒绝

class Store {
  message = message;
  AntdModal = null;
  searchReady = false;
  searchIFrameRef = null; // 搜索 iframe 的 ref
  showChildIFrameModal = false; //  当子 iframe 弹窗打开时, 左侧历史数据侧边栏、头部header显示蒙层
  globalConfig = {
    loginBySDK : true,    // 使用用户中心 SDK 登录
    donotLimitInput : true, // 不限制输入长度
    supportRead : true,  // 普通会话，支持朗读
    supportAllRobotOnline : true, // 全部模型支持联网
    supportTheme : false, // 嵌入很多 iframe，不再支持 dark
    supportSelectModelInWebKnowledge : true,  // 知识库会话页，在非客户端是否支持选择模型
    supportPanelWithSimpleAgent : true, // 简版智能体是否支持小电脑
    supportUploadFileWithAllAgent : true,  // true 所有智能体支持上传文件 false 仅简版智能体支持上传文件
    supportKnowledgeWithAgent : true,  // 智能体是否支持知识库 不支持时点附件按钮弹出选择文件
    supportUploadMultipleWithAgent : true, // 智能体上传文件，是否支持多文件
    mcpHtmlGtAttachments : true,  // 预览时，html 优先级高于附件
    supportNewFileInput : true,  // 上传图片、文件、音视频等，是否使用新首页样式
    supportMultiKnowledge : true,  // 是否支持选择多知识库、全选
    supportModelWithMultiKnowledge : true,  // 大模型支持多知识库，并改为交互与智能体一致
    supportKnowledgeWithFlow : true, // 工作流智能体是否支持知识库、文件
    hideFinishedThink : true, // 隐藏已结束的 think 节点
  };
  // 云控
  cloudConfig = {

  };
  cloudConfigReady = false;
  cloudConfigReadyCallback = [];

  is_aiso = false;
  is_super_aiso = false; //超级搜索标记
  is_so = false;
  is_dy_page = false
  is_deep = {}
  //前一页面的路由信息 location
  previousRoute = null;

  get isDark(){
    return this.userConfig.theme == "dark";
  }

  /**
   * 用户设置
   */
  userConfig = {
    volume : 1, // 音量
    lang : "zh", // 语言
    lastLangByUser : "", // 指定的世界，可切换语言
    theme : "light",  // 主题模式
    cooperationCount : 3, // 协作模型数
    hasAskShortcut : false, // 是否已询问创建快捷方式
    xid : "", // 水印
  };
  /** 全局唯一id */
  uniqueId = uuidv4();

  /**
   * 本地记录，完成次数
   */
  actionCount = {};

  /**
   * 避免无限刷新
   */
  maxReloadCount = 3;

  /**
   * 路由跳转
   */
  navigate = (...args) => {};

  /**
   * 常见接口报错
   */
  errorList = {
    // 获取数据失败
    robotInfo : {
      code : 999999,
      msg : `获取数据失败`,
    },
    // 取消操作
    cancel : {
      code : 999998,
      msg : "取消操作",
    },
    // 请求未响应
    noResponse : {
      code : 999997,
      msg : "请求未响应",
    },
    // 请求超时
    timeout : {
      code : 999996,
      msg : "请求超时",
    },
  }

  /**
   * 已打开的各级 Modal
   */
  modalList = [];

  // 服务端时间
  currentTimestamp = 0;

  // 协作人数
  cooperationCountList = [3, 4, 5];

  // appIcon
  get appIcon () {
    return this.isDark ? Conf.appIconDark : Conf.appIcon;
  }

  /**
   * 最低版本号限制
   */
  minVersion = "";
  minClientVersion = "";
  timerMinVersion = null;

  get isDS () {
    return isDS;
  }

  // debug
  debugDebate = HelperCore.IS_LOCAL;
  debugReload = false && HelperCore.IS_LOCAL;
  debugMcp = HelperCore.IS_LOCAL;
  debugSimpleMcp = HelperCore.IS_LOCAL;

  robustWebsocket = null;

  qpush_alias = 'qpush_alias';

  inviteCodeStatus = null;        // 超级mcp智能体邀请码状态, 0:未申请 1申请中 2已通过 3已激活 9拒绝


  constructor () {
    window.Global = this
    window['global_store'] = this
    makeAutoObservable(this);

    this.loadUserConfig();
    this.loadActionCount();
    this.init();
    this.loadCloudConfig();
    this.checkMinVersion();

    if(!HelperCore.IS_ONLINE || HelperCore.IS_PROD){
      window._globalStore = this;
      window._EE = EE;
    }

    lifecycle.addEventListener('statechange', (event) => {
      // ACTIVE 激活
      // PASSIVE 未激活（页面可以看到，但焦点不在此页面，打开开发者工具可以触发此状态）
      // HIDDEN 隐藏，最小化、标签页切换都属于隐藏
      // FROZEN 冻结
      // TERMINATED 结束 （页面被关闭）
      // DISCARDED 废弃（页面内容被浏览器清空）
      switch (event.newState) {
        case 'terminated':
          break;
        case 'hidden':
        case 'frozen':
        case 'active':
          break;
      }
    });
  }

  handleWebSocketMessage = (message) => {
    // console.log("WebSocket 消息", message);
    const { version, operation, payload } = message;

    if (operation === MIOP.OP_BINDACK) {
      request.post(`/upload/push/alias?appsource=so`, {
        app_id : this.qpush_alias,
        device_type : "3", // WEB
      })
      .then(res => {
        // console.log("上传推送别名成功:", res);
      })
      .catch(err => console.error("上传推送别名失败:", err));
    }

    const { ack, data = [] } = payload;
    if (ack) {
      data.forEach(item => {
        try {
          const { id, appId, body} = item;
          const { msgtype, custom_control, notification, transmission } = body;

          let content = {};
          if (transmission?.content) {
            content = JSON.parse(transmission.content);
          }

          const { type, alert, toast, data } = content;
          if (type === 'data') {
            const { cmd, source, extra } = data;

            /**
             * search_history 用户搜索历史记录变更 - /api/user/answer/history
             * assistant_history 机器人会话历史 - /api/assistant/conversation/history
             * knowledge_file_list 知识库列表
             * knowledge_file_status 知识库文件状态
             * knowledge_group_apply 知识库群组新增用户申请
             * knowledge_group_audit 知识库群组申请审批结果
             * user_logout 用户退出登录
             * user_destroy 用户注销账号
             */
            EE.emit(source, data);
          }
        } catch (error) {
          console.error("处理 WebSocket 消息时出错:", error);
        }
      });
    }
  }

  /**
   * 云控
   */
  loadCloudConfig = () => {
    return request.get("/config/cloud", {
      params : {
        key : [
          `${Conf.cloudKey}_web_config`,  // Web 配置
          'assistant_urm_reason',
          'assistant_model_tag',
          'assistant_model_pk_library',   // 竞技场
          'assistant_model_pk_library2',
          'assistant_model_pk_mark',
          'assistant_llm_coordination_library', // 多模型协作
          'assistant_model_show',
          "assistant_llm_coordinationpk_library", // 组队较量
          'assistant_model_debate_library', // 辩论赛
          'assistant_model_debate_library2',
          'assistant_robot_set', // 联网搜索
          'assistant_ds_shortcut_dlg_duration', // 纳米 ai弹窗间隔
          // 'assistant_model_debate_debater_voice', // 辩论赛 tts 配置
          'assistant_ability_tab', // 类似gpt的sug
          'assistant_web_banner', // 首页banner
          'assistant_left_side_tools_v2',  // 左侧栏配置
          'assistant_left_side_tools',  // 左侧栏配置
          'assistant_chatdoc_params', // 知识库
          'assistant_home_rec_questions', // 首页推荐提问列表
          'assistant_agent_home_config', // 智能体首页配置
          'assistant_knowledge_autofolder', // 自动创建知识库目录 ID
          'assistant_aivideo_trylist',
          'assistant_home_modeltab', // 首页模型管理Tab
          'assistant_aivideo_promptopt', // 生视频用
          'assistant_aiimage_promptopt', // 生图用
          'assistant_aiagent_roles', // 创建mcp模型列表
          'assistant_aivideo_effectsrecommend', // 生视频特效推荐列表
          'assistant_aiimagevideo_imagecompression', // 视频图片广场缩略图规则
          'assistant_mcp_server_config', // mcp 服务端配置
          'assistant_aiimagevideo_creatorprotocol', // 发布协议
          'assistant_aiagent_max_limit',  // 限制次数的智能体
          'assistant_mcp_config', // mcp工具限制
          'assistant_llm_mcp', // 支持mcp工具的模型
          'assistant_aiso_home_category', // ai搜索首页领域分类
          'assistant_chat_kn_select_mode',  // 知识库默认选择模式
          'assistant_specify_gen_file_type',  // 首页多模态输出
          'assistant_aiso_home_category_line2', // 首页简单智能体
          'assistant_aiso_gaokao_agent_white_list', // 高考智能体白名单
          'assistant_home_case', // 首页案例
        ].join(","),
      },
    })
    .then(res => {
      const { data = {} } = res;
      try{
        runInAction(() => {
          let robot_online_set = data['assistant_robot_set']?.map?.robot_online_set;
          if (robot_online_set) {
            try {
              robot_online_set = JSON.parse(robot_online_set)?.map;
            } catch (err) {}
          }

          // chat 对话知识库云控
          let assistantChatDocParams = {}
          let assistant_chatdoc_params = data['assistant_chatdoc_params']?.map
          if (assistant_chatdoc_params) {
            try {
              Object.entries(assistant_chatdoc_params).forEach(([key, value]) => {
                assistantChatDocParams[key] = JSON.parse(value)
              })
            } catch (err) {}
          }
          this.updateCloudConfig({
            webConfig : data[`${Conf.cloudKey}_web_config`]?.map || {},
            feedbackReasons: data['assistant_urm_reason']?.list || [],
            assistantModelTag: (data['assistant_model_tag']?.list || []).filter(item => item.isshow != "noshow"),
            assistantModelPkQuestions: data['assistant_model_pk_library2']?.list || [],
            assistantModelPkGroups: data['assistant_model_pk_library']?.list || [],
            assistantModelPkMap: data['assistant_model_pk_library']?.map || [],
            assistantModelPkMark: data['assistant_model_pk_mark']?.list || [],
            assistantLLMCooperationLibrary: data['assistant_llm_coordination_library']?.list || [],
            assistantModelShow: data['assistant_model_show']?.list || [],
            assistantLLMCoordinationpkLibrary: data['assistant_llm_coordinationpk_library']?.list || [],
            assistantDebateGroups: data['assistant_model_debate_library']?.list || [],
            assistantDebateQuestions: data['assistant_model_debate_library2']?.list || [],
            assistantRobotOnlieSet: robot_online_set || [],
            assistantChatDocParams,
            assistantDsShortcutDlgDuration: data['assistant_ds_shortcut_dlg_duration']?.map || [],
            // assistantDebateTTS: data['assistant_model_debate_debater_voice']?.list || [],
            assistantAbilityTabList: data['assistant_ability_tab']?.list || [],
            assistantAbilityTabMap: data['assistant_ability_tab']?.map || {},
            assistantHomeBanner: data['assistant_web_banner']?.list || [],
            assistantHomeRecQuestions: data['assistant_home_rec_questions']?.list || [],
            assistantAgentHomeConfig: data['assistant_agent_home_config']?.map || {},
            assistantLeftSideTools: (data['assistant_left_side_tools_v2']?.list || []).filter(item => item.url),
            assistantKnowledgeAutofolder: data['assistant_knowledge_autofolder']?.map || {},
            assistantHomeModelTab: data['assistant_home_modeltab']?.list || [],
            assistantAiImagePromptOpt: data['assistant_aiimage_promptopt'] || {},
            assistantAiVideoPromptOpt: data['assistant_aivideo_promptopt'] || {},
            assistantAiagentRoles: data['assistant_aiagent_roles']?.list || [],
            assistantAiVideoEffectsRecommend: data['assistant_aivideo_effectsrecommend'] || {} ,
            assistantAiImageVideoImageCompression: data['assistant_aiimagevideo_imagecompression']?.map || {
              compression: '', enable: 'off', url: '',
            },
            assistantMcpServerConfig: data['assistant_mcp_server_config']?.map || {},
            assistantAiimagevideoCreatorprotocol: data['assistant_aiimagevideo_creatorprotocol']?.map || {},
            assistantAiagentMaxLimit: (data['assistant_aiagent_max_limit']?.list || []).map(item => item.ai_agent_id),
            assistantLlmMcp: data['assistant_llm_mcp']?.map || {},
            assistantMcpConfig: data['assistant_mcp_config']?.map || {},
            assistantAisoFieldCategory: data['assistant_aiso_home_category']?.list || [],
            /**
             * pc_model_kn_mode 大模型
             * pc_sou_kn_mode 搜索
             * pc_ai_agent_kn_mode 智能体
             *
             * 全选 1
             * 全部选 2
             * 选择个人 3
             */
            assistantChatKnSelectMode: data['assistant_chat_kn_select_mode']?.map || {},
            assistantSpecifyGenFileType: (data['assistant_specify_gen_file_type']?.list || []).filter(item => item.status != 1),
            assistantAisoHomeCategoryLine2: (data['assistant_aiso_home_category_line2']?.list || []).filter(item => item.is_hide != 1),
            assistantGaokaoAgentList: (data['assistant_aiso_gaokao_agent_white_list']?.list || []).map(item => item.agent_id),
            assistant_home_case: data['assistant_home_case']?.map || {}
          });

          if(data[`${Conf.cloudKey}_web_config`]?.map?.grayscale == 1){
            HelperCore.addClass(document.body, "page-grayscale");
          }
        })
      } catch(e){}
    })
    .catch((res) => {})
    .finally(() => {
      runInAction(() => {
        this.updateCloudConfig({
        });
      })

      runInAction(() => {
        this.cloudConfigReady = true;
        this.doCloudReady();
      })
    })
  }
  updateCloudConfig (data) {
    runInAction(() => {
      this.cloudConfig = {
        ...this.cloudConfig,
        ...data,
      }
    });
  }
  whenCloudReady (fn = () => {}) {
    if(this.cloudConfigReady){
      try{
        fn();
      } catch(e){}
    }
    else {
      this.cloudConfigReadyCallback.push(fn);
    }
  }
  doCloudReady () {
    if(this.cloudConfigReadyCallback.length){
      this.cloudConfigReadyCallback.forEach(fn => {
        try{
          fn();
        } catch(e){}
      });
      this.cloudConfigReadyCallback = [];
    }
  }

  /**
   * H5 页面刷新
   * 避免无限刷新
   */
  reloadPage = () => {
    const reloadCount = this.userConfig.reloadCount || 0;
    // 不再刷新
    if(reloadCount >= this.maxReloadCount){
      this.setUserConfig({
        reloadCount : 0,
      });

      reportToNRobotWithBasicInfo('重复刷新');
      return;
    }
    this.setUserConfig({
      reloadCount : reloadCount + 1,
    });
    EE.emit("prepare_to_reload");
    setTimeout(() => {
      location.reload();
    }, 0);
  }

  /**
   * location.href 排查
   * @param {String} url
   * @param {Boolean} replace
   */
  hrefNavigate = (url, replace) => {
    if(replace){
      location.replace(url);
    }
    else {
      location.href = url;
    }
  }

  /**
   * 返回 或 回到首页
   * @param {?String} target 没有历史时，跳到哪里
   */
  goBack = (target) => {
    if(history.length > 2){
      this.navigate(-1);
      return;
    }

    if(target && typeof target == "string"){
      this.navigate(target);
      return;
    }

    this.gotoHome();
  }

  /**
   * 返回首页
   */
  gotoHome = (replace = false) => {
    if(this.isKownledgeChat()){
      return;
    }

    if (location.pathname.startsWith("/teamhome")) {
      return
    }
    this.gotoChatHome(replace)
  }

  /**
   * 返回智能体首页
   */
  gotoAgentHome = (replace = false) => {
    if(location.pathname == "/tools/aiagent"){
      return;
    }

    this.navigate("/tools/aiagent", {replace});
  }

  /**
   * 返回大模型首页
   */
  gotoChatHome = (replace = false) => {
    if(location.pathname == "/teamhome"){
      return;
    }

    this.navigate("/teamhome", {replace});
  }

  /**
   * 返回首页
   */
  gotoSearchHome = (replace = false) => {
    if(location.pathname == "/sosearch"){
      return;
    }
    this.navigate("/sosearch", {replace});
  }
  gotoSearchPage = (cid, replace = false) => {
    const pathname = `/sosearch/${cid}`;
    if(location.pathname == pathname){
      return;
    }
    this.navigate(pathname, {replace});
  }

  /**
   * 返回智能体首页
   */
  gotoAgentHome = (replace = false) => {
    this.navigate("/tools/aiagent", {replace});
  }

  /**
   * 重新打开 APP
   * (跳到首页并刷新)
   */
  reloadApp = () => {
    this.hrefNavigate(HelperCore.repaireUrl("/"));
  }
  setPreviousRoute = (location) => {
    this.previousRoute = location;
  }

  loadActionCount () {
    const config = Local.getItem(ZM_USER_ACTION_COUNT);
    if(config){
      this.actionCount = {
        ...this.actionCount,
        ...config,
      }
    }
  }
  addActionCount (key) {
    runInAction(() => {
      this.actionCount[key] = (this.actionCount[key] || 0) + 1;

      Local.setItem(ZM_USER_ACTION_COUNT, this.actionCount);
    });
  }
  getActionCount (key) {
    return this.actionCount[key] || 0;
  }

  // 用户设置
  loadUserConfig () {
    const config = Local.getItem(ZM_USER_CONFIG);
    if(config){
      this.userConfig = {
        ...this.userConfig,
        ...config,
      }

      this.checkTheme();
    }
  }
  /**
   * 更新用户设置
   * @param {Object} config
   */
  setUserConfig (config) {
    runInAction(() => {
      this.userConfig = {
        ...this.userConfig,
        ...config,
      }

      if(config.theme){
        this.checkTheme();
      }

      Local.setItem(ZM_USER_CONFIG, this.userConfig);
    });
  }
  checkTheme = () => {
    HelperCore[this.userConfig.theme != "dark" ? "removeClass" : "addClass"](document.body, "dark");
  }
  setTheme = (theme) => {
    HelperCore[theme != "dark" ? "removeClass" : "addClass"](document.body, "dark");
  }

  /**
   * 更新网页 icon/title
   * 统一入口
   */
  setDocumentInfo = ({ title, icon } = {}) => {
    if(title) {
      document.title = HelperCore.substring(title, 400);
    }
    if(icon) {
      try{
        document.querySelector("link[rel^='shortcut']").href = icon;
      } catch(e){}
    }
  }

  /**
   * 注册、关闭 Modal
   */
  regModal (modal) {
    const id = HelperCore.uniqueId();
    this.modalList.push({
      id,
      modal,
    });
    return id;
  }
  delModal (id) {
    this.modalList = this.modalList.filter(item => item.id != id);
  }
  closeModal (id) {
    if(!id){
      this.closeAllModal();
      return;
    }
    const modal = this.modalList.find(item => item.id == id);
    if(modal){
      modal.modal.close();
      // eslint-disable-next-line
      this.modalList = tis.modalList.filter(item => item.id != id);
    }
  }
  closeAllModal = () => {
    this.modalList.forEach(modal => {
      modal.modal.close();
    });
    this.modalList = [];
  }

  init () {
    if(window.globalConfig){
      this.globalConfig = {
        ...this.globalConfig,
        ...window.globalConfig,
      };
    }

    if(HelperCore.isPhone()){
      HelperCore.addClass(document.body, "page-phone");
    }
  }

  /**
   * 当前服务器时间
   * @param {Number} currentTimestamp
   */
  updateCurrentTimestamp (currentTimestamp) {
    this.currentTimestamp = currentTimestamp;
  }
  loadCurrentTimestamp = async () => {
    return this.checkMinVersion();
  }

  /**
   * 最低版本号限制
   */
  checkMinVersion () {
    clearTimeout(this.timerMinVersion);
    return request.get("/config/cloud", {
      params : {
        key : "assistant_web_version_limit",
      },
    })
    .then(res => {
      const { data = {}, timestamp } = res;
      runInAction(() => {
        try{
          this.updateCurrentTimestamp(timestamp);
          this.minVersion = data.assistant_web_version_limit.map.web;
          this.minClientVersion = data.assistant_web_version_limit.map.weishi;
        } catch(e){}
      });
    })
    .catch(() => {})
    .finally(() => {
      runInAction(() => {
        this.timerMinVersion = setTimeout(() => {
          this.checkMinVersion();
        }, 10 * 60 * 1000);
      });
    });
  }

  toggleTheme = () => {
    this.setUserConfig({
      theme : this.userConfig.theme == "dark" ? "light" : "dark",
    })
  }

  isActiveCooperationCount (count) {
    return this.cooperationCountList.includes(count);
  }

  setData (key, value) {
    this[key] = value;
  }

  getRobotOnlineSet(robot_id) {
    if(this.globalConfig.supportAllRobotOnline){
      return true;
    }

    const list = this.cloudConfig?.assistantRobotOnlieSet || [];
    return list.find(item => item.robot_id === robot_id && item.online_set) ? true : false;
  }

  getRobotDeepSet(robot_id) {
    const list = this.cloudConfig?.assistantRobotOnlieSet || [];

    // debug
    // HelperCore.log(`getRobotDeepSet`, robot_id, JSON.stringify(list));

    return list.find(item => item.robot_id === robot_id && item.depth_set) ? true : false;
  }

  robotAiso(state) {
    runInAction(() => {
      this.is_super_aiso = state;
    });
  }

  // 无state时获取状态，有state时设置状态
  robotOnlineSo(robot_id, state) {
    if(!robot_id){
      return false;
    }

    const list = this.cloudConfig?.assistantRobotOnlieSet || [];
    const res = list.find(item => item.robot_id === robot_id) || (this.globalConfig.supportAllRobotOnline ? {} : null);
    // 不支持联网的模型
    if(!res){
      return false;
    }
    const localKey = 'robot_so';
    if (res && typeof state !== 'undefined') {
      res.online_set_default = state ? 'on' : 'off';
      Local.setItem(localKey, state ? 'on' : 'off');
      this.is_so = state;
    } else {
      const localRobotSo = Local.getItem(localKey) || '';
      let val = false;
      if (localRobotSo !== '') { // 优先用户本地设置
        val = localRobotSo === 'on' ? true : false;
      } else { // 取云控
        val = res?.online_set_default === 'on' ? true : false;
      }
      runInAction(() => {
        this.is_so = val;
      })
      return val;
    }
  }

  // 无state时获取状态，有state时设置状态
  robotDynamicPageSo(robot_id, state) {
    if(!robot_id){
      return false;
    }
    const localKey = 'robot_dypage';
    if (typeof state !== 'undefined') {
      Local.setItem(localKey, state ? 'on' : 'off');
      this.is_dy_page = state;
    } else {
      const localRobotSo = Local.getItem(localKey) || '';
      let val = false;
      if (localRobotSo !== '') { // 优先用户本地设置
        val = localRobotSo === 'on' ? true : false;
      }
      runInAction(() => {
        this.is_dy_page = val;
      })
      return val;
    }
  }

  // 无state时获取状态，有state时设置状态
  robotDeepSo(robot_id, state) {
    if(!robot_id || (!navbarStore.isDSModel(robot_id) && robot_id != Conf.roleIds.knowledge)){
      return false;
    }
    const localKey = `robot_deep_${robot_id}`;
    if (typeof state !== 'undefined') { // set
      Local.setItem(localKey, state ? 'on' : 'off');
      runInAction(() => {
        this.is_deep = {
          ...this.is_deep,
          [robot_id]: state
        };
      })

    } else {
      // 首次访问没有值

      let localRobotDeep = Local.getItem(localKey);

      if (!localRobotDeep) {
        const list = this.cloudConfig?.assistantRobotOnlieSet || [];
        list.forEach(item => {
          if (item.robot_id === robot_id) {
            console.info('depth default', item)
            this.is_deep = {
              ...this.is_deep,
              [robot_id]: item.depth_set_default === 'on' ? true : false
            };
          }
        })
        // Local.setItem(localKey, 'on');
        // runInAction(() => {
        //   this.is_deep = {
        //     ...this.is_deep,
        //     [robot_id]: true
        //   };
        // })
      } else {
        runInAction(() => {
          this.is_deep = {
            ...this.is_deep,
            [robot_id]: localRobotDeep == 'on' ? true : false
          };
        })
      }
      return this.is_deep[robot_id]
    }
  }

  isHomePage () {
    return location.pathname == "/";
  }

  /**
   * 智能体对话起始页
   */
  isAiagentPage () {
    return location.pathname.startsWith("/tools/aiagent");
  }

  /**
   * AI搜索首页及结果页
   */
  isAiso () {
    return location.pathname.startsWith("/sosearch") || location.pathname.startsWith("/aichat") || location.pathname == "/" || location.pathname.startsWith("/examples");
  }
  /**
   * 仅AI搜索首页
   */
  isAisoHome() {
    return ['/', '/sosearch'].includes(location.pathname)
  }

  /**
   * 知识库嵌入页
   */
  isKownledgeChat () {
    return location.pathname == "/knowledge/chat";
  }

  /**
   * 智能体
   */
  isAgentPage () {
    return location.pathname.startsWith("/agentchat") ||
           location.pathname.startsWith("/tools/aiagent")
  }

  /**
   * 大模型
   */
  isChatPage () {
    return location.pathname.startsWith("/chat")
  }

  /**
   * 智能体对话起始页
   */
  isAiagentChat () {
    return location.pathname.startsWith("/tools/aiagent");
  }

  /**
   * 是否限免的智能体
   */
  isLimitedAgent (aiAgentId) {
    if(!this.cloudConfig.assistantAiagentMaxLimit?.length || !aiAgentId){
      return false;
    }
    return this.cloudConfig.assistantAiagentMaxLimit.includes(aiAgentId);
  }

  /** 获取超级智能体邀请状态 */
  getInviteStaus = async () => {
    const res = await request({
      url: '/ai_agent/invite/status',
      method: 'get',
    });
    this.inviteCodeStatus = res.data.status;
    return res?.data?.status;
  }

  /**
   * 设置子 iframe 弹窗打开时, 左侧历史数据侧边栏、头部header显示蒙层
   * @param {Boolean} show
   */
  setShowChildIFrameModal = (show) => {
    this.showChildIFrameModal = show;
  }

  setSearchIFrameRef = (ref) => {
    this.searchIFrameRef = ref;
  }

}

const globalStore = new Store();
export default globalStore;
